import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonToolbar,
  Form,
  Loader,
  Container,
  Content,
  Checkbox,
  Modal,
} from "rsuite";
import { CompanyServices } from "../../../core/services/CompanyServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./Companies.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  displayAmountField,
  displayDateField,
  displayField,
  displayYesNo,
} from "../../../utils/helpers";

const ViewCompanyModal = (props: any) => {
  const { t } = useTranslation();
  const companyViewId = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const [loader, setLoader] = useState(false);
  const [companyInfo, setCompanyInfo] = useState<any>({});
  const [address, setAddress] = useState<any>({});
  async function getViewCompanyDetail(id: number) {
    try {
      setLoader(true);
      const res = await CompanyServices.viewCompany(id);
      setLoader(false);
      if (res && res.data && res.data.data) {
        setCompanyInfo({ ...res.data.data });
      }
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    getViewCompanyDetail(companyViewId);
  }, []);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={props.status}
        backdrop={false}
        onClose={(e: any) => {
          props.toggle("");
        }}
      >
        <Modal.Header>
          <h4 className="text-center">
            {t("VIEW")} {t("DETAIL")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="companies">
            <Container className="container">
              {companyInfo && Object.keys(companyInfo).length ? (
                <Content>
                  <Form layout="inline">
                    <div style={{ width: "200px" }}>
                      <div>
                        <img
                          style={{
                            borderRadius: "100%",
                            width: 100,
                            height: 100,
                            border: "1px solid black",
                          }}
                          src={
                            companyInfo && companyInfo?.company_logo_large
                              ? companyInfo.company_logo_large
                              : UtilityServices.getLoggedInUser(
                                  "company_default_logo"
                                )
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <Form.Group controlId="comp_name">
                      <Form.ControlLabel>
                        {t("COMPANY")} {t("NAME")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.comp_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="comp_code">
                      <Form.ControlLabel>
                        {t("COMPANY")} {t("CODE")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.comp_code}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="company_type">
                      <Form.ControlLabel>
                        {t("COMPANY")} {t("TYPE")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${companyInfo?.company_type?.type_name}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="mobile">
                      <Form.ControlLabel>{t("MOBILE")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.mobile}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="store_count">
                      <Form.ControlLabel>
                        {t("STORE")} {t("COUNT")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.store_count}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="currency">
                      <Form.ControlLabel>{t("CURRENCY")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.currency}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="tax_no">
                      <Form.ControlLabel>{t("TAX_NO")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.tax_no}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="pan_no">
                      <Form.ControlLabel>{t("PAN_NO")} : </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.pan_no}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <h5 className="mt-3 mb-2">{t("ADDRESS")}</h5>
                    <Form.Group controlId="house_no">
                      <Form.ControlLabel>{t("HOUSE_NO")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.house_no}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="building">
                      <Form.ControlLabel>{t("BUILDING")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${companyInfo?.building?.building_name}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="landmark">
                      <Form.ControlLabel>{t("LANDMARK")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.landmark}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="area">
                      <Form.ControlLabel>{t("AREA")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.area?.area_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="pincode">
                      <Form.ControlLabel>{t("PINCODE")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.pincode}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="city">
                      <Form.ControlLabel>{t("CITY")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.city?.city_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="state">
                      <Form.ControlLabel>{t("STATE")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.state?.state_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="country">
                      <Form.ControlLabel>{t("COUNTRY")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.country?.country_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <h5 className="mt-3 mb-2">
                      {t("OWNER")} {t("DETAIL")}
                    </h5>
                    <Form.Group controlId="owner_name">
                      <Form.ControlLabel>{t("NAME")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.primary_admin?.name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="owner_phone">
                      <Form.ControlLabel>{t("MOBILE")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.primary_admin?.mobile}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="owner_email">
                      <Form.ControlLabel>{t("EMAIL")}:</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.primary_admin?.email}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <h5 className="mt-3 mb-2">
                      {t("CONTACT_PERSON")} {t("DETAIL")}
                    </h5>
                    <Form.Group controlId="contact_person1_name">
                      <Form.ControlLabel>
                        {t("CONTACT_PERSON1")} {t("NAME")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.contact_person1_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contact_person1_phone">
                      <Form.ControlLabel>
                        {t("CONTACT_PERSON1")} {t("MOBILE")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.contact_person1_phone}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contact_person1_email">
                      <Form.ControlLabel>
                        {t("CONTACT_PERSON1")} {t("EMAIL")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.contact_person1_email}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contact_person2_name">
                      <Form.ControlLabel>
                        {t("CONTACT_PERSON2")} {t("NAME")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.contact_person2_name}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contact_person2_phone">
                      <Form.ControlLabel>
                        {t("CONTACT_PERSON2")} {t("MOBILE")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.contact_person2_phone}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contact_person2_email">
                      <Form.ControlLabel>
                        {t("CONTACT_PERSON2")} {t("EMAIL")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(`${companyInfo?.contact_person2_email}`)}
                      </Form.ControlLabel>
                    </Form.Group>
                    <h5 className="mt-3 mb-2">
                      {t("LAST")} {t("ACTIVE")} {t("CONTRACT")}
                    </h5>
                    <Form.Group controlId="contract_from">
                      <Form.ControlLabel>
                        {t("CONTRACT")} {t("START")} {t("DATE")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayDateField(
                          `${companyInfo?.active_contract?.contract_from}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contract_to">
                      <Form.ControlLabel>
                        {t("CONTRACT")} {t("END")} {t("DATE")}:
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayDateField(
                          `${companyInfo?.active_contract?.contract_to}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contract_billing_rate">
                      <Form.ControlLabel>
                        {t("BILLING")} {t("RATE")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayAmountField(
                          `${companyInfo?.active_contract?.contract_billing_rate}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="bill_payment_frequency">
                      <Form.ControlLabel>
                        {t("BILLING")} {t("FREQUENCY")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${companyInfo?.active_contract?.bill_payment_frequency_name}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="automate_bill">
                      <Form.ControlLabel>
                        {t("AUTOMATE")} {t("BILL")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayYesNo(
                          `${companyInfo?.active_contract?.automate_bill}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="po_number">
                      <Form.ControlLabel>
                        {t("PO")} {t("NUMBER")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${companyInfo?.active_contract?.po_number}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="agreement_number">
                      <Form.ControlLabel>
                        {t("AGREEMENT")} {t("NUMBER")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${companyInfo?.active_contract?.agreement_number}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="client_contract_type">
                      <Form.ControlLabel>
                        {t("CONTRACT")} {t("TYPE")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${companyInfo?.active_contract?.client_contract_type_name}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contract_for">
                      <Form.ControlLabel>
                        {t("CONTRACT")} {t("FOR")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${companyInfo?.active_contract?.contract_for_name}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="contract_remarks">
                      <Form.ControlLabel>{t("REMARKS")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${companyInfo?.active_contract?.contract_remarks}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="is_internal_ad_allowed">
                      <Form.ControlLabel>
                        {t("INTERNAL")} {t("AD")} {t("ALLOWED")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayYesNo(
                          `${companyInfo?.active_contract?.is_internal_ad_allowed}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="is_external_ad_allowed">
                      <Form.ControlLabel>
                        {t("EXTERNAL")} {t("AD")} {t("ALLOWED")} :
                      </Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayYesNo(
                          `${companyInfo?.active_contract?.is_external_ad_allowed}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="music_licenses">
                      <Form.ControlLabel>{t("LICENSES")} :</Form.ControlLabel>
                      <Form.ControlLabel>
                        {displayField(
                          `${companyInfo?.active_contract?.music_licenses_name}`
                        )}
                      </Form.ControlLabel>
                    </Form.Group>
                  </Form>
                </Content>
              ) : null}
            </Container>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewCompanyModal;
